const SvgData3 = (props) => (
  <>
    <path
      d="M0 96c26.51 0 48-21.49 48-48S26.51 0 0 0v96ZM96 96c-26.51 0-48-21.49-48-48S69.49 0 96 0v96Z"
      fill={props.p40}
    />
  </>
);

export default SvgData3;
